"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSACTIONAL_EMAIL = exports.TIMELINE = exports.TICKETS = exports.SOCIAL = exports.REPORTS = exports.PROJECTS = exports.OAUTH = exports.LISTS = exports.LANDING_PAGES = exports.INTEGRATION_SYNC = exports.HUBDB = exports.FORMS = exports.FILES = exports.EMAIL = exports.E_COMMERCE = exports.CONTENT_SETTINGS = exports.CONTENT = exports.CONTACTS = exports.BUSINESS_INTELLIGENCE = exports.BLOG = exports.AUTOMATION = exports.ACTIONS = void 0;
var ACTIONS = 'actions';
exports.ACTIONS = ACTIONS;
var AUTOMATION = 'automation';
exports.AUTOMATION = AUTOMATION;
var BLOG = 'blog';
exports.BLOG = BLOG;
var BUSINESS_INTELLIGENCE = 'business-intelligence';
exports.BUSINESS_INTELLIGENCE = BUSINESS_INTELLIGENCE;
var CONTACTS = 'contacts';
exports.CONTACTS = CONTACTS;
var CONTENT = 'content';
exports.CONTENT = CONTENT;
var CONTENT_SETTINGS = 'content-settings';
exports.CONTENT_SETTINGS = CONTENT_SETTINGS;
var E_COMMERCE = 'e-commerce';
exports.E_COMMERCE = E_COMMERCE;
var EMAIL = 'email';
exports.EMAIL = EMAIL;
var FILES = 'files';
exports.FILES = FILES;
var FORMS = 'forms';
exports.FORMS = FORMS;
var HUBDB = 'hubdb';
exports.HUBDB = HUBDB;
var INTEGRATION_SYNC = 'integration-sync';
exports.INTEGRATION_SYNC = INTEGRATION_SYNC;
var LANDING_PAGES = 'landing-pages';
exports.LANDING_PAGES = LANDING_PAGES;
var LISTS = 'lists';
exports.LISTS = LISTS;
var OAUTH = 'oauth';
exports.OAUTH = OAUTH;
var PROJECTS = 'projects';
exports.PROJECTS = PROJECTS;
var REPORTS = 'reports';
exports.REPORTS = REPORTS;
var SOCIAL = 'social';
exports.SOCIAL = SOCIAL;
var TICKETS = 'tickets';
exports.TICKETS = TICKETS;
var TIMELINE = 'timeline';
exports.TIMELINE = TIMELINE;
var TRANSACTIONAL_EMAIL = 'transactional-email';
exports.TRANSACTIONAL_EMAIL = TRANSACTIONAL_EMAIL;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/scopes/ScopeGroup.js
// module id = 272
// module chunks = 209 210 211 212